import Experience from './Experience.js';
import Workden from './WorkdenRoom/Workden.js';
import Environment from "./WorkdenRoom/Lighting.js";
import * as THREE from 'three'

export default class World
{
    constructor()
    {
        // Event Bus instance
        this.eventDispatcher = new THREE.EventDispatcher();

        // get ref to Experience singleton
        this.experienceRef = new Experience();
        this.sceneRef = this.experienceRef.threeJSscene;        
        this.resourcesRef = this.experienceRef.resources;

        // Setup
        this.workDenScene = new Workden();

        // Takes care of setting up environment lighting
        this.environment = new Environment();

        //this.workDenScene.initializeSpecialObjectBehaviors();        
        //console.log("Dispatching World Ready event");
        setTimeout(() => {
            this.eventDispatcher.dispatchEvent({ type: 'worldReady' });
        }, 0); 
        // defer to next tick to avoid Race condition and 
        // the chance that subscribers miss the Event
    }

    on(event, callback) 
    {
        this.eventDispatcher.addEventListener(event, callback);
    }

    update()
    {
        if (this.workDenScene)
        {
            this.workDenScene.update();
        }
    }
}